{
  "listingTableConfig": {
    "columns": [
      {
        "fieldName": "documentNo",
        "displayName": "Shipping Bill No",
        "dataType": "STRING"
      },
      {
        "fieldName": "exportCargoMetadata.shippingBillDate",
        "displayName": "Shipping Bill Date",
        "dataType": "DATETIME"
      },
      {
        "fieldName": "accountHolder.name",
        "displayName": "Freight Forwarder",
        "dataType": "STRING"
      },
      {
        "fieldName": "exporter.name",
        "displayName": "Exporter",
        "dataType": "STRING"
      },
      {
        "fieldName": "portOfLoading.name",
        "displayName": "Port of Loading",
        "dataType": "STRING"
      },
      {
        "fieldName": "hazardous",
        "displayName": "Hazardous",
        "dataType": "BOOLEAN",
        "thStyleConfig": {
          "width": "60px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "display": "flex",
            "align-items": "center",
            "border-radius": "16px",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center"
          },
          "conditions": [
            {
              "expression": "eq(value, 'true')",
              "icon": "assets/icons/frame_icon.svg",
              "iconPosition": "left",
              "iconStyleProperties": {
                "width": "16px",
                "height": "16px",
                "background": "#D92D20"
              },
              "styleProperties": {
                "gap": "4px",
                "border": "1px solid var(--Error-200, #FECDCA)",
                "background": "var(--Error-50, #FEF3F2)",
                "color": "var(--Error-700, #B42318)"
              }
            },
            {
              "expression": "eq(value, 'false')",
              "styleProperties": {
                "padding": "2px 8px",
                "width": "40px",
                "border": "1px solid var(--Gray-200, #E4E7EC)",
                "background": "var(--Gray-50, #F9FAFB)",
                "color": "var(--Gray-700, #344054)"
              }
            }
          ]
        }
      },
      {
        "fieldName": "exportCargoMetadata.cargoDescription",
        "displayName": "Cargo Description",
        "dataType": "STRING"
      },
      {
        "fieldName": "exportCargoMetadata.cartingCommunication",
        "displayName": "Carting Communication",
        "dataType": "BOOLEAN",
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "exportCargoMetadata.pcinNo",
        "displayName": "PCIN Number",
        "dataType": "STRING"
      },
      {
        "fieldName": "exportCargoMetadata.leoNo",
        "displayName": "Leo Number",
        "dataType": "STRING",
        "styleConfig": {
          "type": "badge"
        }
      },
      {
        "fieldName": "exportCargoMetadata.cartingCommunication",
        "displayName": "Carting Communication",
        "dataType": "BOOLEAN",
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "createdBy",
        "displayName": "Created By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "createdDate",
        "displayName": "Created Date",
        "dataType": "DATETIME",
        "sortable": true
      }
    ]
  },
  "searchBarConfig": {
    "placeHolder": "Search by shipping bill no",
    "filters": [
      {
        "name": "DOCUMENT_NO_CONTAINS",
        "alias": "DOCUMENT_NO_CONTAINS"
      }
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "documentNo",
        "displayLabel": "Document No",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "EQ": "DOCUMENT_NO_EQUALS",
          "CONTAINS": "DOCUMENT_NO_CONTAINS"
        }
      }
    ],
    "useNewContract": true
  },
  "defaultFilters": {
    "filterConditions": [
      {
        "name": "DOCUMENT_TYPE_EQUALS",
        "alias": "DOCUMENT_TYPE_EQUALS",
        "value": [
          "SHIPPING_BILL"
        ]
      }
    ],
    "expression": "DOCUMENT_TYPE_EQUALS"
  }
}
